import type {
  CenterLayerApiRawResponse,
  CenterLayerApiResponse,
} from '@/domains/centerLayer/centerLayer.entity';

/**
 * Mapper para transformar datos de la API raw a datos funcionales
 * Cumple con SRP - Solo responsabilidad de mapeo de datos
 */
class CenterLayerApiMapper {
  /**
   * Convierte la respuesta raw del API a la estructura requerida
   */
  rawToEntity(rawResponse: CenterLayerApiRawResponse): CenterLayerApiResponse {
    if (
      !rawResponse.success ||
      !rawResponse.data ||
      rawResponse.data.length === 0
    ) {
      throw new Error('Respuesta de la API inválida');
    }

    // tomar el primer elemento del array
    const firstCenterData = rawResponse.data[0];

    return {
      // sede: this.mapCenterName(firstCenterData.sede),
      sede: firstCenterData.sede,
      data: firstCenterData.data,
    };
  }
}

export const centerLayerApiMapper = new CenterLayerApiMapper();
